<template>
  <div>
  <v-list-item ripple class="px-1" >
    <v-list-item-avatar class="my-0 ml-0 mr-1">
      <v-img
          eager
          :src="orderPromo.promo.image"
      />
    </v-list-item-avatar>
    <v-list-item-content class="py-0">
      <v-list-item-title>
        {{ orderPromo.promo.name }}
      </v-list-item-title>
      <v-list-item-subtitle>
        ${{ orderPromo.price }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="showRemoveButton" class="ma-0">
      <v-btn x-small icon @click="removeOrderPromo()">
        <v-icon>delete</v-icon>
      </v-btn>
    </v-list-item-action>



  </v-list-item>
  <template v-for="orderItem in orderPromo.items">
    <customer-cart-detail-promo-product
        :order-item="orderItem" :key="orderItem.id"
    ></customer-cart-detail-promo-product>
  </template>
  </div>
</template>

<script>

import CustomerCartDetailPromoProduct from './CustomerCartDetailPromoProduct.vue'

export default {
  name: "CustomerCartDetailPromo",
  props: {
    orderPromo: {
      type: Object,
      required: true
    },
    showRemoveButton: {
      type: Boolean,
      default: true
    }
  },
  components: {CustomerCartDetailPromoProduct},
  methods:{
    removeOrderPromo() {
      this.$store.commit('removeOrderPromo', this.orderPromo)
    }
  }
}
</script>

<style scoped>

</style>
